var map = {
	"./EMC Academic Associate, Data Science and Big Data Analytics_DELL EMC.jpg": 721,
	"./Electronic Circuit Desig and PCB Fabrication_MEGAS.jpg": 995,
	"./JavaScript Algorithms and Data Structures Masterclass_UDEMY.jpg": 532,
	"./Oracle Certified Associate, Java SE 8 Programmer_ORACLE.png": 208,
	"./React - The Complete Guide (incl Hooks, React Router, Redux)_UDEMY.jpg": 11,
	"./Road Step Awareness Programme_RIGHT MAP INFORMATION AND SERVICES.jpg": 109,
	"./Robotics-Hands On Experience_VORTON TECH SOLUTIONS.jpg": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;